// SubMenu.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const SubMenu = ({ items, isMobile = false, toggleMainMenu }) => {
  const baseClass = [
    "py-2",
    isMobile ? "px-6 hover:bg-gray-100" : "px-4 hover:bg-gray-300",
    "text-gray-700",
    "transition-colors duration-300",
    "block"
  ].join(" ");
    
  return (
    <div className={isMobile ? "py-1" : "py-1 bg-white rounded-md shadow-xl ring-1 ring-black ring-opacity-5"}>
      {items.map((item, index) => (
        <Link 
          key={index} 
          to={item.path}
          className={`${baseClass} ${index === 0 ? 'rounded-t-md' : ''} ${index === items.length - 1 ? 'rounded-b-md' : ''}`}
          onClick={isMobile ? toggleMainMenu : undefined}
        >
          {item.label}
        </Link>
      ))}
    </div>
  );
};

export default SubMenu;